// @flow
import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'
import cx from 'classnames'

type Props = {
  children: Node,
  className: string,
}

export const Italic = ({ children, className }: Props) => (
  <span className={cx('italic', className)}>{children}</span>
)

export const Paragraph = styled.p``

export const DisplayBody = styled.div`
  font-size: 1rem;
  line-height: 1.5;
`



// WEBPACK FOOTER //
// ./src/components/typography/body.js